<template>
  <div v-if="tutorias.length > 0">
    <h3 class="mt-5">Dados do tutor(a)</h3>
    <div v-for="(tutoria,index) in tutorias">
      <div class="d-flex align-items-center justify-content-between perfil-tutorial-text-info-box">
        <div class="d-flex align-items-center">
          <i class="fas fa-user"></i>
          <div>
            <label for="nomeTutor">Nome</label>
            <div class="perfil-tutorial-text-info">{{tutoria.nome}}</div>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-between perfil-tutorial-text-info-box">
        <div class="d-flex align-items-center">
          <i class="fas fa-at"></i>
          <div>
            <label for="nomeEmail">E-mail</label>
            <div class="perfil-tutorial-text-info">{{tutoria.email}}</div>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-between perfil-tutorial-text-info-box">
        <div class="d-flex align-items-center">
          <i class="fas fa-mobile-alt"></i>
          <div>
            <label for="nomeTelefone">Telefone</label>
            <div class="perfil-tutorial-text-info">{{tutoria.telefone}}</div>
          </div>
        </div>
      </div>
      <div v-if="tutoria.turma" class="d-flex align-items-center justify-content-between perfil-tutorial-text-info-box">
        <div class="d-flex align-items-center">
          <i class="fas fa-chalkboard-teacher"></i>
          <div>
            <label for="nomeTurma">Turma</label>
            <div class="perfil-tutorial-text-info">{{tutoria.turma}}</div>
          </div>
        </div>
      </div>
      <div v-if="index+1 != tutorias.length">
        <hr>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="perfil-tutorial-text-info">Nenhum tutor(a) encontrado</div>
  </div>
</template>

<script>
import UsuarioAPI from '@/api/usuario-api'

export default {
  name: 'Tutores',
  props: {
    aluno: Object
  },
  data () {
    return {
      tutorias: []
    }
  },
  async mounted () {
    const loader = this.$loading.show()
    let tutorias = await UsuarioAPI.pegaTutorias()
    tutorias.map(turma => {
      turma.tutores.map(tutor => {
        if (tutorias.length > 1) {
          this.tutorias.push({
            'nome': tutor.nome,
            'email': tutor.email,
            'telefone': tutor.telefone,
            'turma': turma.nome + ' (' + turma.codigo + ')'
          })
        } else {
          this.tutorias.push({
            'nome': tutor.nome,
            'email': tutor.email,
            'telefone': tutor.telefone
          })
        }
      })
    })
    loader.hide()
  }
}
</script>
